import React from 'react';
import Employees from '../Employees/Employees';
export default () => <Employees user />;



// WEBPACK FOOTER //
// ./src/views/StudentService/User/Users.js